import React from "react";
import {
  FaCouch,
  FaFireAlt,
  FaHeadphones,
  FaHome,
  FaLaptop,
  FaMobileAlt,
  FaPaintBrush,
  FaShoppingBag,
  FaSpa,
  FaStar,
  FaTshirt,
  FaUtensils,
  FaUserAlt,
  FaVolumeUp,
  FaRegClock,
} from "react-icons/fa";

const featuredCategories = [
  {
    id: "electronics",
    title: "Electronics",
    route: "/products/electronics",
    icon: <FaLaptop className="text-3xl" />,
  },
  {
    id: "fashion",
    title: "Fashion",
    route: "/products/fashion",
    icon: <FaTshirt className="text-3xl" />,
  },
  {
    id: "home-living",
    title: "Home & Living",
    route: "/products/home-living",
    icon: <FaHome className="text-3xl" />,
  },
  {
    id: "beauty",
    title: "Beauty",
    route: "/products/beauty",
    icon: <FaSpa className="text-3xl" />,
  },
  {
    id: "audio",
    title: "Earbuds",
    route: "/products/electronics/audio",
    icon: <FaHeadphones className="text-3xl" />,
  },
  {
    id: "speakers",
    title: "Speakers",
    route: "/products/electronics/audio",
    icon: <FaVolumeUp className="text-3xl" />,
  },
  {
    id: "wearables",
    title: "Smart Watch",
    route: "/products/electronics/wearables",
    icon: <FaRegClock className="text-3xl" />,
  },
  {
    id: "phones",
    title: "Mobile Phone",
    route: "/products/electronics",
    icon: <FaMobileAlt className="text-3xl" />,
  },
];

export default function CategorySection() {
  return (
    <section className="mt-5 sm:mt-10 px-4 sm:px-6">
      <div className="text-center">
        <h3 className="text-lg sm:text-3xl font-extrabold tracking-tight text-slate-900 ">
          Featured Category
        </h3>
        <p className="text-sm text-slate-600 sm:text-base">
          Get your desired product from featured category!
        </p>
      </div>

        {/* <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-4 sm:gap-4 lg:grid-cols-8"> */}
      <div className="mt-4 sm:mt-6 grid gap-3 grid-cols-4 sm:gap-4 lg:grid-cols-8">
        {featuredCategories.map((category) => (
          <button
            key={category.id}
            type="button"
            onClick={() => (window.location.hash = category.route)}
            className="group flex flex-col items-center justify-center gap-1 rounded-lg bg-white px-3 py-3 text-center shadow-sm ring-1 ring-slate-100 transition hover:-translate-y-0.5 hover:shadow-md"
          >
            <span className="text-slate-600 transition group-hover:text-slate-900">
              {category.icon}
            </span>
            <span className="text-xs font-semibold text-slate-800 sm:text-sm truncate w-full">
              {category.title}
            </span>
          </button>
        ))}
      </div>
    </section>
  );
}
